const apps = {
  apps: "אפליקציות",
  sections: "קטגוריות",
  searchPlaceholder: "חפש אפליקציה...",
  all: "הכל",
  noApps: "אין אפליקציות ברישום",
  status: {
    built: "בנוי",
    inProgress: "בפיתוח",
    planned: "מתוכנן",
    idea: "רעיון",
  },
} as const;

export default apps;